// extracted by mini-css-extract-plugin
export default {"root":"QuantityForm_root__hqfWl"};